/* eslint-disable react/no-danger */
/* eslint react/no-did-mount-set-state: 0 */

import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {MoreOrLess} from '@homeaway/react-collapse';
import EdapViewTracker from '../../components/common/edap-view-tracker/EdapViewTracker';
import {onViewMoreOrLessClick} from './events';

import './styles.less';

const COLLAPSED_TEXT_MAX_HEIGHT = 96;
const MAX_LINE_COUNT = 4;

class SEOIntroductionParagraphComponent extends PureComponent {
    static propTypes = {
        id: PropTypes.string,
        introduction: PropTypes.string.isRequired,
        labels: PropTypes.shape({
            buttonViewLess: PropTypes.string,
            buttonViewMore: PropTypes.string,
        }),
        ACTION_LOCATION: PropTypes.string,
        isMobile: PropTypes.bool,
    };

    static defaultProps = {
        id: 'seo-introduction-paragraph-id',
        ACTION_LOCATION: 'collapsible-paragraph',
        isMobile: false,
    };

    constructor(props) {
        super(props);

        this.state = {
            lineCount: 0,
        };

        this.introRef = React.createRef(null);
    }

    componentDidMount() {
        this.setLineCount();
    }

    setLineCount = () => {
        const {current = {}} = this.introRef;
        const {clientHeight = 0} = current || {};
        const lineCount =
            clientHeight > COLLAPSED_TEXT_MAX_HEIGHT ? MAX_LINE_COUNT : 0;

        this.setState({lineCount});
    };

    render() {
        const {id, labels, introduction, ACTION_LOCATION, content} = this.props;
        const collapsibleContentProps = {
            lines: this.state.lineCount,
            moreText: labels.buttonViewMore,
            lessText: labels.buttonViewLess,
            onExpandedChange: onViewMoreOrLessClick,
        };

        const showMoreLessButton =
            this.state.lineCount > 0 ? collapsibleContentProps : {};
        return content || introduction ? (
            <div className={'seo-introduction-paragraph container module'}>
                <EdapViewTracker
                    eventData={{
                        action_location: ACTION_LOCATION,
                        position_fired: 'top',
                    }}
                    edapEvent={'content_module.presented'}
                />
                {
                    <MoreOrLess
                        id={id}
                        expanded={false}
                        {...showMoreLessButton}
                    >
                        <div
                            className="collapsible-content__body-text"
                            ref={this.introRef}
                        >
                            {introduction}
                        </div>
                    </MoreOrLess>
                }
                <EdapViewTracker eventData={{actionlocation: ACTION_LOCATION}}>
                    <div style={{minHeight: '1px', clear: 'both'}} />
                </EdapViewTracker>
                <EdapViewTracker
                    eventData={{
                        action_location: ACTION_LOCATION,
                        position_fired: 'bottom',
                    }}
                    edapEvent={'content_module.presented'}
                />
            </div>
        ) : null;
    }
}

export default SEOIntroductionParagraphComponent;
